import { Injectable } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { CommunicationService } from 'src/app/services/communication';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from 'projects/communication/src/app/services';

@Injectable({
  providedIn: 'root',
})
export class ReportExplosiveService {
  private baseUrl: string;
  constructor(
    private communicationService: CommunicationService,
    private cacheService: CacheService,
    private http: HttpClient,
    private urlBuilder: UrlBuilderService,
  ) {
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   * get data report Explosive
   */
  public getReportExplosiveData(selectedFilters: IOutputFilter): Promise<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.baseUrl}/Report/GetExplosiveReport`;
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * get data excel report explosive
   */
  public getReportExplosiveExcel(selectedFilters: IOutputFilter): Observable<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.urlBuilder.apiUrl}/Report/GetExplosiveReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * set Params
   */
  private setParams(selectedFilters: IOutputFilter): any {
    const companyId = this.cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      companyId,
    };
  }
}
